
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/messages",
      function () {
        return require("private-next-pages/companies/messages/index.tsx");
      }
    ]);
  